<ui-modal modalTitle="WeQuote Tour">
	<p class="text-bold text-large">Are you sure you want to cancel the WeQuote tutorial?</p>
	<p>We recommend all new users complete this walkthrough. The average completion time is 5 minutes.</p>
	<p>If you decide to leave the tutorial, you will be able to restart it by clicking the button on your user profile.</p>

	<button type="submit" class="btn btn-danger" (click)="cancelTutorial()" [disabled]="disabled" ui-modal-footer>Cancel Tutorial</button>
	<div class="flex-weight-1" ui-modal-footer></div>
	<button type="button" class="btn btn-success" (click)="modal.close()" [disabled]="disabled" ui-modal-footer>Continue Tutorial</button>
</ui-modal>
